export default {
    ordensServico: [],
    ordemServico: {},
    ultimaAtualizacaoListaOrdemServico: Date
}